export const SUPPORTED_FIAT_CURRENCIES = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BYR',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRO',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'STD',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMK',
  'ZMW',
  'ZWL',
];
export const SUPPORTED_CRYPTO_CURRENCIES = [
  'BINANCE',
  'BTC',
  'COINBASE',
  'ETH',
  'LNBC',
  'PYUSD',
  'testBTC',
  'USDC',
  'USDC_POLY',
  'USDC_SOL',
  'USDT',
  'USDT_POLY',
  'USDT_SOL',
  'USDT_TRC20',
  'USDT_POLY',
  'USDC_ARB',
  'USDT_ARB',
  'XSGD',
];
export const SUPPORTED_OVERALL_CURRENCIES = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BINANCE',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTC',
  'BTN',
  'BWP',
  'BYN',
  'BYR',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLF',
  'CLP',
  'CNY',
  'COINBASE',
  'COP',
  'CRC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'ETH',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LNBC',
  'LRD',
  'LSL',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRO',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'PYUSD',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'STD',
  'SVC',
  'SYP',
  'SZL',
  'testBTC',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'USDC',
  'USDC_POLY',
  'USDC_SOL',
  'USDT',
  'USDT_POLY',
  'USDT_SOL',
  'USDT_TRC20',
  'USDC_ARB',
  'USDT_ARB',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMK',
  'ZMW',
  'ZWL',
];

// PAYOUTS
export const PAYOUT_STATUS = {
  // https://developers.triple-a.io/docs/triplea-api-doc/0d10abc289f23-payout-statuses
  NEW: 'new',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
  DONE: 'done',
  INVALID: 'invalid',
  PENDING_APPROVAL: 'pending_approval',
  PENDING_BROADCAST: 'pending_broadcast',
  PENDING_CONFIRMATION: 'pending_confirmation',
  PENDING_AUTHORIZATION: 'pending_authorization',
};
export const PAYOUT_PURPOSES = {
  BILLS: { value: 'BILLS', display : 'Bills'},
  COMPANY_EXPENSES: { value: 'COMPANY_EXPENSES', display:'Company Expenses'},
  EDUCATION: { value: 'EDUCATION', display: 'Education' },
  FAMILY_SUPPORT: { value: 'FAMILY_SUPPORT', display: 'Family Support' },
  GIFT_DONATION: { value: 'GIFT_AND_DONATION', display: 'Gift and Donation' },
  HEALTH: { value: 'HEALTH', display: 'Health' },
  INSURANCE: { value: 'INSURANCE', display: 'Insurance' },
  INVESTMENTS: { value: 'INVESTMENT', display: 'Investment' },
  LOAN_PAYMENT: { value: 'LOAN_PAYMENT', display: 'Loan Payment' },
  REMITTANCE: { value: 'REMITTANCE', display: 'Remittance' },
  SALARY: { value: 'SALARY_PAYMENT', display: 'Salary Payment' },
  TAXES: { value: 'TAXES', display: 'Taxes' },
  TRAVEL: { value: 'TRAVEL', display: 'Travel' },
  OTHER: { value: 'OTHER', display: 'Other' }
};

export const PAYOUT_MODES = {
  SENDING: 'sending',
  RECEIVING: 'receiving'
};

export const PAYOUT_SOURCE_OF_FUNDS = {
  BUSINESS: {value : 'BUSINESS', display: 'Business'},
  CASH: {value: 'CASH', display: 'Cash'},
  GIFT: { value: 'GIFT', display: 'Gift' },
  LOTTERY: { value: 'LOTTERY', display: 'Lottery' },
  SALARY: { value: 'SALARY', display: 'Salary' },
  SAVINGS: { value: 'SAVINGS', display: 'Savings' },
  OTHER: { value: 'OTHER', display: 'Other' }
};

export const PAYOUT_RELATIONSHIP_VALUES = {
  // FAMILY: { value: 'FAMILY', display: 'Family' },
  FRIENDS: { value: 'FRIEND', display: 'Third party' },
  SELF: { value: 'SELF', display: 'Self' },
  OTHER: { value: 'OTHER', display: 'Other' }
};

export const PAYOUT_ACCOUNT_TYPES = {
  CORPORATE: { value: 'company', display: 'Corporate'},
  INDIVIDUAL : {value: 'individual', display: 'Individual'} 
};

export const FIAT_ID_TYPE = {
  DRIVING_LICENSE: { value: 'DRIVING_LICENSE', display: 'Driving license' },
  NATIONAL_ID: { value: 'NATIONAL_ID', display: 'National ID' },
  PASSPORT: { value: 'PASSPORT', display: 'Passport' },
  RESIDENT_CARD: { value:'RESIDENT_CARD', display: 'Resident card'},
  SOCIAL_SECURITY: { value: 'SOCIAL_SECURITY', display: 'Social Security' },
  TAX_ID: { value: 'TAX_ID', display: 'Tax ID' }, 
  OTHER: { value: 'OTHER', display: 'Other' }
};

export const PAYOUT_DOC_TYPES = {
  DRIVING_LICENSE: { value: 'driving_license', display: 'Driving license' },
  NATIONAL_ID: { value: 'national_id', display: 'National ID' },
  PASSPORT: { value: 'passport', display: 'Passport' },
  BUSINESS_INCORPORATION: { value: 'business_incorporation', display: 'Business Incorporation' },
  INVOICE: { value: 'invoice', display: 'Invoice' },
  PAYROLL: { value: 'payroll', display: 'Payroll' },
  BANK_STATEMENT: { value: 'bank_statement', display: 'Bank Statement' },
};

export const FIAT_ACCOUNT_FIELD_CATEGORIES = {
  ADDRESS: 'Address',
  INDIVIDUAL_DETAILS: 'Individual particulars',
  IDENTIFICATION: 'Identification',
  COMPANY_DETAILS: 'Registration details',
  OTHER: 'Other',
};

export const FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  PASSWORD: 'password',
  DATE: 'date',
  SELECT: 'select',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  TEXTAREA: 'textarea',
  FILE: 'file',
};

export const FIAT_ACCOUNT_FIELDS = {
  address: {
    name: 'Address',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.ADDRESS,
    placeholder: 'Enter address',
    type: FIELD_TYPES.TEXT,
    backend_name: 'address',
    order: 1,
  },
  country_code: {
    name: 'Country',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.ADDRESS,
    placeholder: 'Select country',
    type: FIELD_TYPES.SELECT,
    backend_name: 'country_code',
    order: 3,
  },
  city: {
    name: 'City',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.ADDRESS,
    placeholder: 'Enter city',
    type: FIELD_TYPES.TEXT,
    backend_name: 'city',
    order: 2,
  },
  province_state: {
    name: 'Province/State',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.ADDRESS,
    placeholder: 'Enter Province/State',
    type: FIELD_TYPES.TEXT,
    backend_name: 'province_state',
    order: 4,
  },
  zip_code: {
    name: 'Zip Code',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.ADDRESS,
    placeholder: 'Enter zip code',
    type: FIELD_TYPES.TEXT,
    backend_name: 'zip_code',
    order: 4,
  },
  first_name: {
    name: 'First Name',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Enter first name',
    type: FIELD_TYPES.TEXT,
    backend_name: 'first_name',
    order: 1,
  },
  last_name: {
    name: 'Last Name',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Enter last name',
    type: FIELD_TYPES.TEXT,
    backend_name: 'last_name',
    order: 1,
  },
  date_of_birth: {
    name: 'Date of Birth',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Enter date of birth',
    type: FIELD_TYPES.DATE,
    backend_name: 'date_of_birth',
    order: 2,
  },
  nationality: {
    name: 'Nationality',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Select nationality',
    type: FIELD_TYPES.SELECT,
    backend_name: 'Nationality',
    order: 2,
  },
  gender: {
    name: 'Gender',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Select gender',
    type: FIELD_TYPES.SELECT,
    backend_name: 'gender',
    order: 3,
  },
  occupation: {
    name: 'Occupation',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.INDIVIDUAL_DETAILS,
    placeholder: 'Enter occupation',
    type: FIELD_TYPES.TEXT,
    backend_name: 'occupation',
    order: 4,
  },
  identification_type: {
    name: 'Identification Type',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.IDENTIFICATION,
    placeholder: 'Select identification type',
    type: FIELD_TYPES.SELECT,
    backend_name: 'identification_type',
    order: 1,
  },
  identification_number: {
    name: 'Identification Number',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.IDENTIFICATION,
    placeholder: 'Enter identification number',
    type: FIELD_TYPES.TEXT,
    backend_name: 'identification_number',
    order: 1,
  },
  identification_issuer: {
    name: 'Country of issuance',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.IDENTIFICATION,
    placeholder: 'Select country',
    type: FIELD_TYPES.SELECT,
    backend_name: 'identification_issuer',
    order: 3,
  },
  identification_issue_date: {
    name: 'Issue Date',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.IDENTIFICATION,
    placeholder: 'Enter issue date',
    type: FIELD_TYPES.DATE,
    backend_name: 'identification_issue_date',
    order: 2,
  },
  identification_expiry_date: {
    name: 'Expiry Date',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.IDENTIFICATION,
    placeholder: 'Enter expiry date',
    type: FIELD_TYPES.DATE,
    backend_name: 'identification_expiry_date',
    order: 2,
  },
  registered_name: {
    name: 'Registered name',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter registered name',
    type: FIELD_TYPES.TEXT,
    backend_name: 'registered_name',
    order: 1,
  },
  registration_number: {
    name: 'Registration number',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter registration number',
    type: FIELD_TYPES.TEXT,
    backend_name: 'registration_number',
    order: 2,
  },
  registration_type: {
    name: 'Registration type',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter registration type (License, Tax ID...) ',
    type:  FIELD_TYPES.TEXT, // FIELD_TYPES.SELECT,
    backend_name: 'registration_type',
    order: 2,
  },
  registration_date: {
    name: 'Registration date',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter registration date',
    type: FIELD_TYPES.DATE,
    backend_name: 'registration_date',
    order: 3,
  },
  registration_expiry_date: {
    name: 'Registration Expiry date',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter expiry date',
    type: FIELD_TYPES.DATE,
    backend_name: 'registration_expiry_date',
    order: 3,
  },
  registration_country: {
    name: 'Registration country',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Select registration country',
    type: FIELD_TYPES.SELECT,
    backend_name: 'registration_country',
    order: 4,
  },
  trading_name: {
    name: 'Trading name',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Enter trading name',
    type: FIELD_TYPES.TEXT,
    isOptional: true,
    backend_name: 'trading_name',
    order: 2,
  },
  external_id: {
    name: 'External ID',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Enter external ID',
    type: FIELD_TYPES.TEXT,
    isOptional: true,
    backend_name: 'external_id',
    order: 2,
  },
  email: {
    name: 'Email',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Enter email',
    type: FIELD_TYPES.TEXT,
    backend_name: 'email',
    order: 1,
  },
  mobile_phone: {
    name: 'Mobile Phone',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Ex: +6512341234',
    type: FIELD_TYPES.TEXT,
    backend_name: 'mobile_phone',
    order: 1,
  },
  phone_number: {
    name: 'Phone Number',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Ex: +1234567890',
    type: FIELD_TYPES.TEXT,
    backend_name: 'phone_number',
    order: 1,
  },
  mobile_number: {
    name: 'Mobile Number',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Ex: +1234567890',
    type: FIELD_TYPES.TEXT,
    backend_name: 'mobile_number',
    order: 1,
  },
  business_nature: {
    name: 'Business Nature',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.COMPANY_DETAILS,
    placeholder: 'Select business nature',
    type: FIELD_TYPES.SELECT,
    backend_name: 'business_nature',
    order: 3,
  },
  remarks: {
    name: 'Remarks',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Enter any remarks',
    type: FIELD_TYPES.TEXT,
    backend_name: 'remarks',
    order: 5,
  },
  alias: {
    name: 'Alias',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Enter alias',
    type: FIELD_TYPES.TEXT,
    backend_name: 'alias',
    order: 4,
  },
  role: {
    name: 'Role',
    category: FIAT_ACCOUNT_FIELD_CATEGORIES.OTHER,
    placeholder: 'Enter role',
    type: FIELD_TYPES.TEXT,
    backend_name: 'role',
    order: 3,
  }
};

export const FIAT_BANK_ACCOUNT_TYPES = {
  CHECKING: { val: 'CHECKING', display: 'Checking' },
  SAVINGS: { val: 'SAVINGS', display: 'Savings' },
};

export const FIAT_ROUTING_TYPES = {
  ABA: { val: 'ABA', display: 'ABA' },
  BIK: { val: 'BIK', display: 'BIK' },
  BSB: { val: 'BSB', display: 'BSB' },
  IFSC: { val: 'IFSC', display: 'IFSC' },
  SORT: { val: 'Sort code', display: 'Sort code' },
  SWIFT: { val: 'SWIFT-BIC', display: 'SWIFT-BIC' },
  ROUTING_NUMBER: { val: 'Routing Number', display: 'Routing number' },
};

export const FIAT_BANK_ACCOUNT_FORMATS = {
  ACC_NUM: { val: 'ACCOUNT NUMBER', display: 'ACCOUNT NUMBER' },
  CBU: { val: 'CBU', display: 'CBU' },
  CBU_ALIAS: { val: 'CBU ALIAS', display: 'CBU ALIAS' },
  CLABE: { val: 'CLABE', display: 'CLABE' },
  IBAN: { val: 'IBAN', display: 'IBAN' },
};

export const FIAT_ACCOUNT_OCCUPATION = {
  FREELANCER: { val: 'FREELANCER', display: 'Freelancer' },
  STUDENT: { val: 'STUDENT', display: 'Student' },
  NURSE: { val: 'NURSE', display: 'Nurse' },
  LAWYER: { val: 'LAWYER', display: 'Lawyer' },
  DOCTOR: { val: 'DOCTOR', display: 'Doctor' },
  PUBLIC_EMPLOYEE: { val: 'PUBLIC_EMPLOYEE', display: 'Public Employee' },
  OFFICE_WORKER: { val: 'OFFICE_WORKER', display: 'Office Worker' },
  GOVERNMENT_OFFICER: { val: 'GOVERNMENT_OFFICER', display: 'Government Officer' },
  RETIREMENT: { val: 'RETIREMENT', display: 'Retirement' },
  TEACHER: { val: 'TEACHER', display: 'Teacher' },
  OFFICER: { val: 'OFFICER', display: 'Officer' },
  AGRICULTURE: { val: 'AGRICULTURE', display: 'Agriculture' },
  SELF_EMPLOYED: { val: 'SELF_EMPLOYED', display: 'Self Employed' },
  UNEMPLOYED: { val: 'UNEMPLOYED', display: 'Unemployed' },
  RETIRED: { val: 'RETIRED', display: 'Retired' },
  OTHER: { val: 'OTHER', display: 'Other' }
};

export const FIAT_ACCOUNT_BUSINESS_NATURE = {
  AGRICULTURE_FOOD_CROPS: { val: 'AGRICULTURE_FOOD_CROPS', display: 'Agriculture/Food Crops' },
  AGRICULTURE_OTHER_CROPS: { val: 'AGRICULTURE_OTHER_CROPS', display: 'Agriculture/Other Crops' },
  AGIRCULTURE_FARMING: { val: 'AGIRCULTURE_FARMING', display: 'Agriculture/Farming' },
  ENERGY_EQUIPMENT_SERVICES: { val: 'ENERGY_EQUIPMENT_SERVICES', display: 'Energy Equipment Services' },
  ENERGY_NON_RENEWABLE_RESOURCES: { val: 'ENERGY_NON_RENEWABLE_RESOURCES', display: 'Energy Non-Renewable Resources' },
  ENERGY_RENEWABLES_RESOURCES: { val: 'ENERGY_RENEWABLES_RESOURCES', display: 'Energy Renewables Resources' },
  FINANCIAL_SERVICES_BANK: { val: 'FINANCIAL_SERVICES_BANK', display: 'Financial Services/Bank' },
  FINANCIAL_SERVICES_INSURANCE: { val: 'FINANCIAL_SERVICES_INSURANCE', display: 'Financial Services/Insurance' },
  FINANCIAL_SERVICES_INVESTMENT: { val: 'FINANCIAL_SERVICES_INVESTMENT', display: 'Financial Services/Investment' },
  FINANCIAL_SERVICES_LENDING: { val: 'FINANCIAL_SERVICES_LENDING', display: 'Financial Services/Lending' },
  FINANCIAL_SERVICES_REMITTANCE: { val: 'FINANCIAL_SERVICES_REMITTANCE', display: 'Financial Services/Remittance' },
  HEALTH_CARE_SERVICES: { val: 'HEALTH_CARE_SERVICES', display: 'Health Care Services' },
  HEALTH_CARE_EQUIPMENT: { val: 'HEALTH_CARE_EQUIPMENT', display: 'Health Care Equipment' },
  HEALTH_CARE_PHARMA_AND_LIFE_SCIENCES: { val: 'HEALTH_CARE_PHARMA_AND_LIFE_SCIENCES', display: 'Health Care Pharma and Life Sciences' },
  INDUSTRIAL_AEROSPACE_DEFENSE: { val: 'INDUSTRIAL_AEROSPACE_DEFENSE', display: 'Industrial/Aerospace Defense' },
  INDUSTRIAL_CONSTRUCTION_ENGINEERING: { val: 'INDUSTRIAL_CONSTRUCTION_ENGINEERING', display: 'Industrial/Construction Engineering' },
  INDUSTRIAL_ELECTRICAL_EQUIPMENT_MACHINERY: { val: 'INDUSTRIAL_ELECTRICAL_EQUIPMENT_MACHINERY', display: 'Industrial/Electrical Equipment Machinery' },
  INFORMATION_TECHNOLOGY_SOFTWARE_SERVICES: { val: 'INFORMATION_TECHNOLOGY_SOFTWARE_SERVICES', display: 'Information Technology/Software Services' },
  INFORMATION_TECHNOLOGY_HARDWARE_EQUIPMENT_COMPONENTS: { val: 'INFORMATION_TECHNOLOGY_HARDWARE_EQUIPMENT_COMPONENTS', display: 'Information Technology/Hardware Equipment Components' },
  INFORMATION_TECHNOLOGY_ECOMMERCE: { val: 'INFORMATION_TECHNOLOGY_ECOMMERCE', display: 'Information Technology/Ecommerce' },
  MANUFACTURING_AUTOMOBILES_AND_COMPONENTS: { val: 'MANUFACTURING_AUTOMOBILES_AND_COMPONENTS', display: 'Manufacturing/Automobiles and Components' },
  MANUFACTURING_CONSUMER_GOODS: { val: 'MANUFACTURING_CONSUMER_GOODS', display: 'Manufacturing/Consumer Goods' },
  MANUFACTURING_FOOD_PRODUCTS: { val: 'MANUFACTURING_FOOD_PRODUCTS', display: 'Manufacturing/Food Products' },
  MATERIALS_METAL_AND_BASIC_MATERIALS: { val: 'MATERIALS_METAL_AND_BASIC_MATERIALS', display: 'Materials/Metal and Basic Materials' },
  MATERIALS_CHEMICALS: { val: 'MATERIALS_CHEMICALS', display: 'Materials/Chemicals' },
  MATERIALS_CONSTRUCTION: { val: 'MATERIALS_CONSTRUCTION', display: 'Materials/Construction' },
  MATERIALS_MANUFACTURING: { val: 'MATERIALS_MANUFACTURING', display: 'Materials/Manufacturing' },
  MEDIA_AND_COMMUNICATION_TELECOMMUNICATION: { val: 'MEDIA_AND_COMMUNICATION_TELECOMMUNICATION', display: 'Media and Communication/Telecommunication' },
  MEDIA_AND_COMMUNICATION_MEDIA_ENTERTAINMENT_SPORTS: { val: 'MEDIA_AND_COMMUNICATION_MEDIA_ENTERTAINMENT_SPORTS', display: 'Media and Communication/Media Entertainment Sports' },
  PROFESSIONAL_SERVICES_LEGAL_HR_CONSULTING: { val: 'PROFESSIONAL_SERVICES_LEGAL_HR_CONSULTING', display: 'Professional Services/Legal HR Consulting' },
  PROFESSIONAL_SERVICES_OTHERS: { val: 'PROFESSIONAL_SERVICES_OTHERS', display: 'Professional Services/Others' },
  PUBLIC_SECTOR_GOVERNMENT_ADMINISTRATION: { val: 'PUBLIC_SECTOR_GOVERNMENT_ADMINISTRATION', display: 'Public Sector/Government Administration' },
  PUBLIC_SECTOR_NGOS: { val: 'PUBLIC_SECTOR_NGOS', display: 'Public Sector/NGOs' },
  PUBLIC_SECTOR_OTHERS: { val: 'PUBLIC_SECTOR_OTHERS', display: 'Public Sector/Others' },
  RETAIL_TRADING_AND_DISTRIBUTION: { val: 'RETAIL_TRADING_AND_DISTRIBUTION', display: 'Retail/Trading and Distribution' },
  RETAIL_RETAILER: { val: 'RETAIL_RETAILER', display: 'Retail/Retailer' },
  RETAIL_FOOD_BEVERAGES: { val: 'RETAIL_FOOD_BEVERAGES', display: 'Retail/Food Beverages' },
  RETAIL_HOTELS_LEISURE_ENTERTAINMENT: { val: 'RETAIL_HOTELS_LEISURE_ENTERTAINMENT', display: 'Retail/Hotels Leisure Entertainment' },
  TRANSPORTATION_ROAD_AND_RAIL: { val: 'TRANSPORTATION_ROAD_AND_RAIL', display: 'Transportation/Road and Rail' },
  TRANSPORTATION_AIR: { val: 'TRANSPORTATION_AIR', display: 'Transportation/Air' },
  TRANSPORTATION_MARINE: { val: 'TRANSPORTATION_MARINE', display: 'Transportation/Marine' },
  TRANSPORTATION_LOGISTICS: { val: 'TRANSPORTATION_LOGISTICS', display: 'Transportation/Logistics' },
  UTILITIES_ENERGY: { val: 'UTILITIES_ENERGY', display: 'Utilities/Energy' },
  UTILITIES_WATER: { val: 'UTILITIES_WATER', display: 'Utilities/Water' },
  REAL_ESTATE: { val: 'REAL_ESTATE', display: 'Real Estate' },
  null: { val: null, display: '' }
};

export const FIAT_FEE_MODES = {
  SHA: {
    value: 'SHA',
    display: 'SHA',
  },
  OUR: {
    value: 'OUR',
    display: 'OUR',
  },
};



// PAYMENTS
export const PAYMENT_STATUS = {
  // https://developers.triple-a.io/docs/triplea-api-doc/0c40f1b88af6a-payment-statuses
  NONE: 'none',
  SHORT: 'short',
  HOLD: 'hold',
  GOOD: 'good',
  INVALID: 'invalid',
};

export const COUNTRIES = [
  { code: 'AF', code3: 'AFG', name: 'Afghanistan', number: '004' },
  { code: 'AL', code3: 'ALB', name: 'Albania', number: '008' },
  { code: 'DZ', code3: 'DZA', name: 'Algeria', number: '012' },
  { code: 'AS', code3: 'ASM', name: 'American Samoa', number: '016' },
  { code: 'AD', code3: 'AND', name: 'Andorra', number: '020' },
  { code: 'AO', code3: 'AGO', name: 'Angola', number: '024' },
  { code: 'AI', code3: 'AIA', name: 'Anguilla', number: '660' },
  { code: 'AQ', code3: 'ATA', name: 'Antarctica', number: '010' },
  { code: 'AG', code3: 'ATG', name: 'Antigua and Barbuda', number: '028' },
  { code: 'AR', code3: 'ARG', name: 'Argentina', number: '032' },
  { code: 'AM', code3: 'ARM', name: 'Armenia', number: '051' },
  { code: 'AW', code3: 'ABW', name: 'Aruba', number: '533' },
  { code: 'AU', code3: 'AUS', name: 'Australia', number: '036' },
  { code: 'AT', code3: 'AUT', name: 'Austria', number: '040' },
  { code: 'AZ', code3: 'AZE', name: 'Azerbaijan', number: '031' },
  { code: 'BS', code3: 'BHS', name: 'Bahamas (the)', number: '044' },
  { code: 'BH', code3: 'BHR', name: 'Bahrain', number: '048' },
  { code: 'BD', code3: 'BGD', name: 'Bangladesh', number: '050' },
  { code: 'BB', code3: 'BRB', name: 'Barbados', number: '052' },
  { code: 'BY', code3: 'BLR', name: 'Belarus', number: '112' },
  { code: 'BE', code3: 'BEL', name: 'Belgium', number: '056' },
  { code: 'BZ', code3: 'BLZ', name: 'Belize', number: '084' },
  { code: 'BJ', code3: 'BEN', name: 'Benin', number: '204' },
  { code: 'BM', code3: 'BMU', name: 'Bermuda', number: '060' },
  { code: 'BT', code3: 'BTN', name: 'Bhutan', number: '064' },
  {
    code: 'BO',
    code3: 'BOL',
    name: 'Bolivia (Plurinational State of)',
    number: '068',
  },
  {
    code: 'BQ',
    code3: 'BES',
    name: 'Bonaire, Sint Eustatius and Saba',
    number: '535',
  },
  { code: 'BA', code3: 'BIH', name: 'Bosnia and Herzegovina', number: '070' },
  { code: 'BW', code3: 'BWA', name: 'Botswana', number: '072' },
  { code: 'BV', code3: 'BVT', name: 'Bouvet Island', number: '074' },
  { code: 'BR', code3: 'BRA', name: 'Brazil', number: '076' },
  {
    code: 'IO',
    code3: 'IOT',
    name: 'British Indian Ocean Territory (the)',
    number: '086',
  },
  { code: 'BN', code3: 'BRN', name: 'Brunei Darussalam', number: '096' },
  { code: 'BG', code3: 'BGR', name: 'Bulgaria', number: '100' },
  { code: 'BF', code3: 'BFA', name: 'Burkina Faso', number: '854' },
  { code: 'BI', code3: 'BDI', name: 'Burundi', number: '108' },
  { code: 'CV', code3: 'CPV', name: 'Cabo Verde', number: '132' },
  { code: 'KH', code3: 'KHM', name: 'Cambodia', number: '116' },
  { code: 'CM', code3: 'CMR', name: 'Cameroon', number: '120' },
  { code: 'CA', code3: 'CAN', name: 'Canada', number: '124' },
  { code: 'KY', code3: 'CYM', name: 'Cayman Islands (the)', number: '136' },
  {
    code: 'CF',
    code3: 'CAF',
    name: 'Central African Republic (the)',
    number: '140',
  },
  { code: 'TD', code3: 'TCD', name: 'Chad', number: '148' },
  { code: 'CL', code3: 'CHL', name: 'Chile', number: '152' },
  { code: 'CN', code3: 'CHN', name: 'China', number: '156' },
  { code: 'CX', code3: 'CXR', name: 'Christmas Island', number: '162' },
  {
    code: 'CC',
    code3: 'CCK',
    name: 'Cocos (Keeling) Islands (the)',
    number: '166',
  },
  { code: 'CO', code3: 'COL', name: 'Colombia', number: '170' },
  { code: 'KM', code3: 'COM', name: 'Comoros (the)', number: '174' },
  {
    code: 'CD',
    code3: 'COD',
    name: 'Congo (the Democratic Republic of the)',
    number: '180',
  },
  { code: 'CG', code3: 'COG', name: 'Congo (the)', number: '178' },
  { code: 'CK', code3: 'COK', name: 'Cook Islands (the)', number: '184' },
  { code: 'CR', code3: 'CRI', name: 'Costa Rica', number: '188' },
  { code: 'HR', code3: 'HRV', name: 'Croatia', number: '191' },
  { code: 'CU', code3: 'CUB', name: 'Cuba', number: '192' },
  { code: 'CW', code3: 'CUW', name: 'Curaçao', number: '531' },
  { code: 'CY', code3: 'CYP', name: 'Cyprus', number: '196' },
  { code: 'CZ', code3: 'CZE', name: 'Czechia', number: '203' },
  { code: 'CI', code3: 'CIV', name: "Côte d'Ivoire", number: '384' },
  { code: 'DK', code3: 'DNK', name: 'Denmark', number: '208' },
  { code: 'DJ', code3: 'DJI', name: 'Djibouti', number: '262' },
  { code: 'DM', code3: 'DMA', name: 'Dominica', number: '212' },
  { code: 'DO', code3: 'DOM', name: 'Dominican Republic (the)', number: '214' },
  { code: 'EC', code3: 'ECU', name: 'Ecuador', number: '218' },
  { code: 'EG', code3: 'EGY', name: 'Egypt', number: '818' },
  { code: 'SV', code3: 'SLV', name: 'El Salvador', number: '222' },
  { code: 'GQ', code3: 'GNQ', name: 'Equatorial Guinea', number: '226' },
  { code: 'ER', code3: 'ERI', name: 'Eritrea', number: '232' },
  { code: 'EE', code3: 'EST', name: 'Estonia', number: '233' },
  { code: 'SZ', code3: 'SWZ', name: 'Eswatini', number: '748' },
  { code: 'ET', code3: 'ETH', name: 'Ethiopia', number: '231' },
  {
    code: 'FK',
    code3: 'FLK',
    name: 'Falkland Islands (the) [Malvinas]',
    number: '238',
  },
  { code: 'FO', code3: 'FRO', name: 'Faroe Islands (the)', number: '234' },
  { code: 'FJ', code3: 'FJI', name: 'Fiji', number: '242' },
  { code: 'FI', code3: 'FIN', name: 'Finland', number: '246' },
  { code: 'FR', code3: 'FRA', name: 'France', number: '250' },
  { code: 'GF', code3: 'GUF', name: 'French Guiana', number: '254' },
  { code: 'PF', code3: 'PYF', name: 'French Polynesia', number: '258' },
  {
    code: 'TF',
    code3: 'ATF',
    name: 'French Southern Territories (the)',
    number: '260',
  },
  { code: 'GA', code3: 'GAB', name: 'Gabon', number: '266' },
  { code: 'GM', code3: 'GMB', name: 'Gambia (the)', number: '270' },
  { code: 'GE', code3: 'GEO', name: 'Georgia', number: '268' },
  { code: 'DE', code3: 'DEU', name: 'Germany', number: '276' },
  { code: 'GH', code3: 'GHA', name: 'Ghana', number: '288' },
  { code: 'GI', code3: 'GIB', name: 'Gibraltar', number: '292' },
  { code: 'GR', code3: 'GRC', name: 'Greece', number: '300' },
  { code: 'GL', code3: 'GRL', name: 'Greenland', number: '304' },
  { code: 'GD', code3: 'GRD', name: 'Grenada', number: '308' },
  { code: 'GP', code3: 'GLP', name: 'Guadeloupe', number: '312' },
  { code: 'GU', code3: 'GUM', name: 'Guam', number: '316' },
  { code: 'GT', code3: 'GTM', name: 'Guatemala', number: '320' },
  { code: 'GG', code3: 'GGY', name: 'Guernsey', number: '831' },
  { code: 'GN', code3: 'GIN', name: 'Guinea', number: '324' },
  { code: 'GW', code3: 'GNB', name: 'Guinea-Bissau', number: '624' },
  { code: 'GY', code3: 'GUY', name: 'Guyana', number: '328' },
  { code: 'HT', code3: 'HTI', name: 'Haiti', number: '332' },
  {
    code: 'HM',
    code3: 'HMD',
    name: 'Heard Island and McDonald Islands',
    number: '334',
  },
  { code: 'VA', code3: 'VAT', name: 'Holy See (the)', number: '336' },
  { code: 'HN', code3: 'HND', name: 'Honduras', number: '340' },
  { code: 'HK', code3: 'HKG', name: 'Hong Kong', number: '344' },
  { code: 'HU', code3: 'HUN', name: 'Hungary', number: '348' },
  { code: 'IS', code3: 'ISL', name: 'Iceland', number: '352' },
  { code: 'IN', code3: 'IND', name: 'India', number: '356' },
  { code: 'ID', code3: 'IDN', name: 'Indonesia', number: '360' },
  {
    code: 'IR',
    code3: 'IRN',
    name: 'Iran (Islamic Republic of)',
    number: '364',
  },
  { code: 'IQ', code3: 'IRQ', name: 'Iraq', number: '368' },
  { code: 'IE', code3: 'IRL', name: 'Ireland', number: '372' },
  { code: 'IM', code3: 'IMN', name: 'Isle of Man', number: '833' },
  { code: 'IL', code3: 'ISR', name: 'Israel', number: '376' },
  { code: 'IT', code3: 'ITA', name: 'Italy', number: '380' },
  { code: 'JM', code3: 'JAM', name: 'Jamaica', number: '388' },
  { code: 'JP', code3: 'JPN', name: 'Japan', number: '392' },
  { code: 'JE', code3: 'JEY', name: 'Jersey', number: '832' },
  { code: 'JO', code3: 'JOR', name: 'Jordan', number: '400' },
  { code: 'KZ', code3: 'KAZ', name: 'Kazakhstan', number: '398' },
  { code: 'KE', code3: 'KEN', name: 'Kenya', number: '404' },
  { code: 'KI', code3: 'KIR', name: 'Kiribati', number: '296' },
  {
    code: 'KP',
    code3: 'PRK',
    name: "Korea (the Democratic People's Republic of)",
    number: '408',
  },
  { code: 'KR', code3: 'KOR', name: 'Korea (the Republic of)', number: '410' },
  { code: 'XK', code3: 'XKX', name: 'Kosovo', number: '383' },
  { code: 'KW', code3: 'KWT', name: 'Kuwait', number: '414' },
  { code: 'KG', code3: 'KGZ', name: 'Kyrgyzstan', number: '417' },
  {
    code: 'LA',
    code3: 'LAO',
    name: "Lao People's Democratic Republic (the)",
    number: '418',
  },
  { code: 'LV', code3: 'LVA', name: 'Latvia', number: '428' },
  { code: 'LB', code3: 'LBN', name: 'Lebanon', number: '422' },
  { code: 'LS', code3: 'LSO', name: 'Lesotho', number: '426' },
  { code: 'LR', code3: 'LBR', name: 'Liberia', number: '430' },
  { code: 'LY', code3: 'LBY', name: 'Libya', number: '434' },
  { code: 'LI', code3: 'LIE', name: 'Liechtenstein', number: '438' },
  { code: 'LT', code3: 'LTU', name: 'Lithuania', number: '440' },
  { code: 'LU', code3: 'LUX', name: 'Luxembourg', number: '442' },
  { code: 'MO', code3: 'MAC', name: 'Macao', number: '446' },
  { code: 'MG', code3: 'MDG', name: 'Madagascar', number: '450' },
  { code: 'MW', code3: 'MWI', name: 'Malawi', number: '454' },
  { code: 'MY', code3: 'MYS', name: 'Malaysia', number: '458' },
  { code: 'MV', code3: 'MDV', name: 'Maldives', number: '462' },
  { code: 'ML', code3: 'MLI', name: 'Mali', number: '466' },
  { code: 'MT', code3: 'MLT', name: 'Malta', number: '470' },
  { code: 'MH', code3: 'MHL', name: 'Marshall Islands (the)', number: '584' },
  { code: 'MQ', code3: 'MTQ', name: 'Martinique', number: '474' },
  { code: 'MR', code3: 'MRT', name: 'Mauritania', number: '478' },
  { code: 'MU', code3: 'MUS', name: 'Mauritius', number: '480' },
  { code: 'YT', code3: 'MYT', name: 'Mayotte', number: '175' },
  { code: 'MX', code3: 'MEX', name: 'Mexico', number: '484' },
  {
    code: 'FM',
    code3: 'FSM',
    name: 'Micronesia (Federated States of)',
    number: '583',
  },
  {
    code: 'MD',
    code3: 'MDA',
    name: 'Moldova (the Republic of)',
    number: '498',
  },
  { code: 'MC', code3: 'MCO', name: 'Monaco', number: '492' },
  { code: 'MN', code3: 'MNG', name: 'Mongolia', number: '496' },
  { code: 'ME', code3: 'MNE', name: 'Montenegro', number: '499' },
  { code: 'MS', code3: 'MSR', name: 'Montserrat', number: '500' },
  { code: 'MA', code3: 'MAR', name: 'Morocco', number: '504' },
  { code: 'MZ', code3: 'MOZ', name: 'Mozambique', number: '508' },
  { code: 'MM', code3: 'MMR', name: 'Myanmar', number: '104' },
  { code: 'NA', code3: 'NAM', name: 'Namibia', number: '516' },
  { code: 'NR', code3: 'NRU', name: 'Nauru', number: '520' },
  { code: 'NP', code3: 'NPL', name: 'Nepal', number: '524' },
  { code: 'NL', code3: 'NLD', name: 'Netherlands (the)', number: '528' },
  { code: 'NC', code3: 'NCL', name: 'New Caledonia', number: '540' },
  { code: 'NZ', code3: 'NZL', name: 'New Zealand', number: '554' },
  { code: 'NI', code3: 'NIC', name: 'Nicaragua', number: '558' },
  { code: 'NE', code3: 'NER', name: 'Niger (the)', number: '562' },
  { code: 'NG', code3: 'NGA', name: 'Nigeria', number: '566' },
  { code: 'NU', code3: 'NIU', name: 'Niue', number: '570' },
  { code: 'NF', code3: 'NFK', name: 'Norfolk Island', number: '574' },
  {
    code: 'MP',
    code3: 'MNP',
    name: 'Northern Mariana Islands (the)',
    number: '580',
  },
  { code: 'NO', code3: 'NOR', name: 'Norway', number: '578' },
  { code: 'OM', code3: 'OMN', name: 'Oman', number: '512' },
  { code: 'PK', code3: 'PAK', name: 'Pakistan', number: '586' },
  { code: 'PW', code3: 'PLW', name: 'Palau', number: '585' },
  { code: 'PS', code3: 'PSE', name: 'Palestine, State of', number: '275' },
  { code: 'PA', code3: 'PAN', name: 'Panama', number: '591' },
  { code: 'PG', code3: 'PNG', name: 'Papua New Guinea', number: '598' },
  { code: 'PY', code3: 'PRY', name: 'Paraguay', number: '600' },
  { code: 'PE', code3: 'PER', name: 'Peru', number: '604' },
  { code: 'PH', code3: 'PHL', name: 'Philippines (the)', number: '608' },
  { code: 'PN', code3: 'PCN', name: 'Pitcairn', number: '612' },
  { code: 'PL', code3: 'POL', name: 'Poland', number: '616' },
  { code: 'PT', code3: 'PRT', name: 'Portugal', number: '620' },
  { code: 'PR', code3: 'PRI', name: 'Puerto Rico', number: '630' },
  { code: 'QA', code3: 'QAT', name: 'Qatar', number: '634' },
  {
    code: 'MK',
    code3: 'MKD',
    name: 'Republic of North Macedonia',
    number: '807',
  },
  { code: 'RO', code3: 'ROU', name: 'Romania', number: '642' },
  { code: 'RU', code3: 'RUS', name: 'Russian Federation (the)', number: '643' },
  { code: 'RW', code3: 'RWA', name: 'Rwanda', number: '646' },
  { code: 'RE', code3: 'REU', name: 'Réunion', number: '638' },
  { code: 'BL', code3: 'BLM', name: 'Saint Barthélemy', number: '652' },
  {
    code: 'SH',
    code3: 'SHN',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    number: '654',
  },
  { code: 'KN', code3: 'KNA', name: 'Saint Kitts and Nevis', number: '659' },
  { code: 'LC', code3: 'LCA', name: 'Saint Lucia', number: '662' },
  {
    code: 'MF',
    code3: 'MAF',
    name: 'Saint Martin (French part)',
    number: '663',
  },
  {
    code: 'PM',
    code3: 'SPM',
    name: 'Saint Pierre and Miquelon',
    number: '666',
  },
  {
    code: 'VC',
    code3: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    number: '670',
  },
  { code: 'WS', code3: 'WSM', name: 'Samoa', number: '882' },
  { code: 'SM', code3: 'SMR', name: 'San Marino', number: '674' },
  { code: 'ST', code3: 'STP', name: 'Sao Tome and Principe', number: '678' },
  { code: 'SA', code3: 'SAU', name: 'Saudi Arabia', number: '682' },
  { code: 'SN', code3: 'SEN', name: 'Senegal', number: '686' },
  { code: 'RS', code3: 'SRB', name: 'Serbia', number: '688' },
  { code: 'SC', code3: 'SYC', name: 'Seychelles', number: '690' },
  { code: 'SL', code3: 'SLE', name: 'Sierra Leone', number: '694' },
  { code: 'SG', code3: 'SGP', name: 'Singapore', number: '702' },
  {
    code: 'SX',
    code3: 'SXM',
    name: 'Sint Maarten (Dutch part)',
    number: '534',
  },
  { code: 'SK', code3: 'SVK', name: 'Slovakia', number: '703' },
  { code: 'SI', code3: 'SVN', name: 'Slovenia', number: '705' },
  { code: 'SB', code3: 'SLB', name: 'Solomon Islands', number: '090' },
  { code: 'SO', code3: 'SOM', name: 'Somalia', number: '706' },
  { code: 'ZA', code3: 'ZAF', name: 'South Africa', number: '710' },
  {
    code: 'GS',
    code3: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    number: '239',
  },
  { code: 'SS', code3: 'SSD', name: 'South Sudan', number: '728' },
  { code: 'ES', code3: 'ESP', name: 'Spain', number: '724' },
  { code: 'LK', code3: 'LKA', name: 'Sri Lanka', number: '144' },
  { code: 'SD', code3: 'SDN', name: 'Sudan (the)', number: '729' },
  { code: 'SR', code3: 'SUR', name: 'Suriname', number: '740' },
  { code: 'SJ', code3: 'SJM', name: 'Svalbard and Jan Mayen', number: '744' },
  { code: 'SE', code3: 'SWE', name: 'Sweden', number: '752' },
  { code: 'CH', code3: 'CHE', name: 'Switzerland', number: '756' },
  { code: 'SY', code3: 'SYR', name: 'Syrian Arab Republic', number: '760' },
  { code: 'TW', code3: 'TWN', name: 'Taiwan', number: '158' },
  { code: 'TJ', code3: 'TJK', name: 'Tajikistan', number: '762' },
  {
    code: 'TZ',
    code3: 'TZA',
    name: 'Tanzania, United Republic of',
    number: '834',
  },
  { code: 'TH', code3: 'THA', name: 'Thailand', number: '764' },
  { code: 'TL', code3: 'TLS', name: 'Timor-Leste', number: '626' },
  { code: 'TG', code3: 'TGO', name: 'Togo', number: '768' },
  { code: 'TK', code3: 'TKL', name: 'Tokelau', number: '772' },
  { code: 'TO', code3: 'TON', name: 'Tonga', number: '776' },
  { code: 'TT', code3: 'TTO', name: 'Trinidad and Tobago', number: '780' },
  { code: 'TN', code3: 'TUN', name: 'Tunisia', number: '788' },
  { code: 'TR', code3: 'TUR', name: 'Turkey', number: '792' },
  { code: 'TM', code3: 'TKM', name: 'Turkmenistan', number: '795' },
  {
    code: 'TC',
    code3: 'TCA',
    name: 'Turks and Caicos Islands (the)',
    number: '796',
  },
  { code: 'TV', code3: 'TUV', name: 'Tuvalu', number: '798' },
  { code: 'UG', code3: 'UGA', name: 'Uganda', number: '800' },
  { code: 'UA', code3: 'UKR', name: 'Ukraine', number: '804' },
  {
    code: 'AE',
    code3: 'ARE',
    name: 'United Arab Emirates (the)',
    number: '784',
  },
  {
    code: 'GB',
    code3: 'GBR',
    name: 'United Kingdom of Great Britain and Northern Ireland (the)',
    number: '826',
  },
  {
    code: 'UM',
    code3: 'UMI',
    name: 'United States Minor Outlying Islands (the)',
    number: '581',
  },
  {
    code: 'US',
    code3: 'USA',
    name: 'United States of America (the)',
    number: '840',
  },
  { code: 'UY', code3: 'URY', name: 'Uruguay', number: '858' },
  { code: 'UZ', code3: 'UZB', name: 'Uzbekistan', number: '860' },
  { code: 'VU', code3: 'VUT', name: 'Vanuatu', number: '548' },
  {
    code: 'VE',
    code3: 'VEN',
    name: 'Venezuela (Bolivarian Republic of)',
    number: '862',
  },
  { code: 'VN', code3: 'VNM', name: 'Viet Nam', number: '704' },
  { code: 'VG', code3: 'VGB', name: 'Virgin Islands (British)', number: '092' },
  { code: 'VI', code3: 'VIR', name: 'Virgin Islands (U.S.)', number: '850' },
  { code: 'WF', code3: 'WLF', name: 'Wallis and Futuna', number: '876' },
  { code: 'EH', code3: 'ESH', name: 'Western Sahara', number: '732' },
  { code: 'YE', code3: 'YEM', name: 'Yemen', number: '887' },
  { code: 'ZM', code3: 'ZMB', name: 'Zambia', number: '894' },
  { code: 'ZW', code3: 'ZWE', name: 'Zimbabwe', number: '716' },
  { code: 'AX', code3: 'ALA', name: 'Åland Islands', number: '248' },
  { code: 'NN', code3: 'NON', name: 'None', number: '001' },
];

export const REFUND_REASON_OPTIONS = [
  { name: 'AML', value: 'aml' },
  { name: 'Requested By Customer', value: 'requested_by_customer' },
];

export const MFA_TYPE = {
  EMAIL: 'email',
  AUTHENTICATOR: 'authenticator',
};

export const DASHBOARD_VERIFICATION_TYPE = {
  OTP: 'otp',
  PASSWORD: 'password',
};


// CRYPTO PAYOUTS
export const CRYPTO_BATCH_PAYOUT_STATUS = {
  PENDING: {
    display : 'Pending',
    backend_name: 'pending',
    definition: 'Payout is pending.',
  },
  PROCESSING: {
    display : 'Processing',
    backend_name: 'processing',
    definition: 'Payout is being processed.',
  },
  FAILED: {
    display : 'Failed',
    backend_name: 'failed',
    definition: 'Payout has failed.',
  },
  COMPLETED: {
    display : 'Completed',
    backend_name: 'completed',
    definition: 'Payout is completed.',
  },
};

export const CRYPTO_BATCH_STATUS = {
  CREATING: {
    display : 'Creating',
    backend_name: 'creating',
    definition: 'Batch is being created.',
  },
  // CREATED: {
  //   display : 'Created',
  //   backend_name: 'created',
  //   definition: 'Payouts are pending creation.',
  // },
  CREATED: {
    display: 'Creating',
    backend_name: 'created',
    definition: 'Batch is being created.',
  },
  PROCESSING: {
    display : 'Processing',
    backend_name: 'processing',
    definition: 'Batch is being processed. Payouts are progressively being created.',
  },
  FAILED: {
    display : 'Batch Failed',
    backend_name: 'failed',
    definition: 'Batch has failed. No payouts were created.',
  },
  PARTIAL_COMPLETED: {
    display : 'Partially Completed',
    backend_name: 'partially_completed',
    definition: 'Batch has been processed but some payouts failed.',
  },
  COMPLETED: {
    display : 'Completed',
    backend_name: 'completed',
    definition: 'Batch is fully processed and payouts are ready for collection.',
  },
};
